import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";

interface PortfolioHealthChartProps {
  onTimeCount: number;
  overdueCount: number;
  criticalCount: number;
}

export function PortfolioHealthChart({ onTimeCount, overdueCount, criticalCount }: PortfolioHealthChartProps) {
  const data = [
    { name: "Em dia", value: onTimeCount, color: "hsl(var(--success))" },
    { name: "Atrasados", value: overdueCount, color: "hsl(var(--warning))" },
    { name: "Críticos (>30 dias)", value: criticalCount, color: "hsl(var(--destructive))" },
  ].filter(item => item.value > 0); // Only show categories with values

  return (
    <Card className="glass">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold tracking-tight">Saúde da Carteira</CardTitle>
        <CardDescription className="text-xs">Distribuição de clientes por status de pagamento</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={280}>
          {data.length === 0 ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-sm text-muted-foreground">Nenhum empréstimo cadastrado ainda</p>
            </div>
          ) : (
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={62}
                outerRadius={96}
                paddingAngle={3}
                stroke="hsl(var(--background))"
                strokeWidth={2}
                dataKey="value"
                label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                labelLine={false}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: "hsl(var(--popover))",
                  border: "1px solid hsl(var(--border))",
                  borderRadius: "12px",
                  fontSize: "12px",
                  boxShadow: "0 12px 32px -8px hsl(0 0% 0% / 0.4)",
                }}
                formatter={(value: number) => `${value} empréstimos`}
              />
              <Legend verticalAlign="bottom" height={36} iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          )}
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
